import React, { useState, useRef } from 'react';

const Switch = ({ id,func }) => {
  const [isChecked, setIsChecked] = useState(false);
  const toggleInputRef = useRef(null);

  const handleChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const toggleChecked = () => {
      
    setIsChecked(!isChecked);
    
    func(id,!isChecked)
};
  // console.log(`State of ${id}:`, isChecked);

  return (
    <div className="switch">
      <span>
        <input
          type="checkbox"
          id={`toggleInput-${IDBDatabase}`}
          checked={isChecked}
          onChange={handleChange}
        />
        <button
          className="slider"
          type="button"
          onClick={toggleChecked}
        >
        </button>
      </span>
      <label
        htmlFor={`toggleInput-${id}`}
        onClick={toggleChecked}
      >
        
      </label>
    </div>
  );
};

export default Switch;